"use strict";
var $dyn;
(function ($dyn) {
    /**
     * @deprecated
     */
    function applyHandler(targetElement, handlerName, options, context) {
        // TODO TFS:3745038 Dead?
        $dyn.logDeprecated("$dyn.applyHandler");
        var handler = $dyn.bindingHandlers[handlerName];
        if (handler.apply) {
            handler(targetElement).apply(options, targetElement.dynContext);
        }
        else {
            $dyn._invokeHandler(handlerName, targetElement, options, context);
        }
    }
    $dyn.applyHandler = applyHandler;
    function _invokeHandler(handlerType, targetElement, value, context) {
        if (!targetElement) {
            $dyn.logError('_invokeHandler for handler type "%s" was called with a null or undefined target element.', handlerType);
            return;
        }
        var begin;
        var executed;
        if ($dyn.debug.performance) {
            executed = false;
            begin = performance.now();
        }
        var handler = $dyn.bindingHandlers[handlerType];
        // Check if the handler has an unwrapobservable flag set to false
        // denoting that we need to pass the observable as it is and not unwrap it
        if (handler.unwrapObservable !== false) {
            value = $dyn.value(value);
        }
        if (!targetElement.dynHandlersExecuted) {
            targetElement.dynHandlersExecuted = {};
        }
        /// #DEBUG
        if (handler.apply) {
            $dyn.logError("Handler " + handlerType + " is not refactored.");
        }
        /// #ENDDEBUG
        var firstTime = !targetElement.dynHandlersExecuted[handlerType];
        var state;
        if (handler.setup && firstTime) {
            state = handler.setup(targetElement, value, context);
            if (state !== undefined) {
                if (!targetElement.dynStates) {
                    targetElement.dynStates = {};
                }
                targetElement.dynStates[handlerType] = state;
            }
            targetElement.dynHandlersExecuted[handlerType] = true;
        }
        if (!targetElement.dynLastHandlerValue) {
            targetElement.dynLastHandlerValue = {};
        }
        if (handler.invoke) {
            var lastValue = targetElement.dynLastHandlerValue ? targetElement.dynLastHandlerValue[handlerType] : undefined;
            state = targetElement.dynStates ? targetElement.dynStates[handlerType] : undefined;
            if ((!handler.shouldInvoke && value !== lastValue) ||
                (handler.shouldInvoke &&
                    handler.shouldInvoke(value, lastValue, state, targetElement, context))) {
                handler.invoke(targetElement, value, lastValue, state, context);
                executed = true;
                targetElement.dynLastHandlerValue[handlerType] = value;
            }
        }
        if ($dyn.debug.performance) {
            var end = performance.now();
            var timing = $dyn.ui.PerformanceTimer._handlerTimings[handlerType];
            if (!timing) {
                timing = $dyn.ui.PerformanceTimer._handlerTimings[handlerType] = { time: 0, count: 0, invoked: 0 };
            }
            timing.time += (end - begin); // times can be overlapping if a handler invokes data binding (like the visible handler)
            timing.count++;
            timing.invoked += executed ? 1 : 0;
        }
        // state may possibly be undefined
        return state;
    }
    $dyn._invokeHandler = _invokeHandler;
    var bindingFunctions;
    (function (bindingFunctions) {
        function $model(modelSelector, dataContext) {
            var model = $dyn.parseModel(modelSelector, dataContext instanceof $dyn.DataContext ? dataContext.current : dataContext);
            if ($dyn.debug.verboseModels) {
                $dyn.log("[html-binding] Model: %o, Selector: %o, Context: %o", $dyn.value(model), modelSelector, dataContext instanceof $dyn.DataContext ? dataContext.current : dataContext);
            }
            return model;
        }
        bindingFunctions.$model = $model;
        function $models(modelSelector, dataContext) {
            var models = $dyn.parseModelCollection(modelSelector, dataContext instanceof $dyn.DataContext ? dataContext.current : dataContext);
            if ($dyn.debug.verboseModels) {
                $dyn.log("[html-binding] Models: %o, Selector: %o, Context: %o", $dyn.value(models), modelSelector, dataContext);
            }
            return models;
        }
        bindingFunctions.$models = $models;
        function $modelCollection(modelSelector, dataContext) {
            var modelCollection = $dyn.parseModelCollection(modelSelector, dataContext instanceof $dyn.DataContext ? dataContext.current : dataContext, true);
            if ($dyn.debug.verboseModels) {
                // $dyn.log('[html-binding] Models: %o, Selector: %o, Context: %o', models, modelSelector, dataContext);
            }
            return modelCollection;
        }
        bindingFunctions.$modelCollection = $modelCollection;
    })(bindingFunctions = $dyn.bindingFunctions || ($dyn.bindingFunctions = {}));
    $dyn._bindingUnwrapCache = {};
    $dyn._bindingCache = {};
    $dyn._bindingsCache = {};
    /**
     * Obtains a function to evaluate the data-dyn-bind expression as a simple object.
     * @description This is used for cases where the bindingTrigger is the mechanism used to trigger handlers rather than
     * observability. When a binding trigger is used the expression can be evaluated as a single object as opposed to when
     * observability is used where it has to be parsed into it's individual components.
     * The expression is also simplified and only supports $data an $element. Support for $index and $vars will likely be added as well.
     */
    function getBasicBindings(element) {
        if (!element.dynBasicBindings) {
            $dyn._parseBasicBindings(element);
        }
        return element.dynBasicBindings;
    }
    $dyn.getBasicBindings = getBasicBindings;
    /**
     * Creates an function that evaluates an element's data-dyn-bind expression as a simple object expression.
     * @description The result is cached on the element as dynBindings.
     */
    function _parseBasicBindings(element) {
        // Function evaluates the data-dyn-bindings attribute and places the results in the dynBasicBindings property on the template root element
        var bindings = element.getAttribute("data-dyn-bind");
        if (bindings && bindings !== "") {
            try {
                element.dynBasicBindings = new Function("$data", "$element", "return {" + bindings + "};");
            }
            catch (e) {
                // Error unhandled here since $dyn.logError will be called on the invalid binding expression in $dyn._parseBindingExpression
            }
        }
    }
    $dyn._parseBasicBindings = _parseBasicBindings;
    /**
     * Creates an evaluator function by parsing a binding expression.
     * @description The evaluator takes current dataContextWrapper as parameter.
     * If the unwrapCurrentDataContext is true, the data-context will be unwrapped if it is an observable
     * while evaluating the expression. As a result, the expression evaluation must be observed
     * so as not to lose future changes to the data-context observable. Default is false.
     */
    function _parseBindingExpression(bindingExpression, unwrapCurrentDataContext) {
        if (unwrapCurrentDataContext === void 0) { unwrapCurrentDataContext = false; }
        var cache;
        if (unwrapCurrentDataContext) {
            bindingExpression = "{" + bindingExpression + "}";
            cache = $dyn._bindingCache;
            if ($dyn._bindingCache[bindingExpression]) {
                return $dyn._bindingCache[bindingExpression];
            }
        }
        else {
            cache = $dyn._bindingUnwrapCache;
            var cachedValue = cache[bindingExpression];
            if (cachedValue) {
                return cachedValue;
            }
        }
        // Current data-context expression depends on unwrapping specification
        var currentDataContextExpression = (unwrapCurrentDataContext === true) ?
            "$dyn.value(dataContextWrapper.current)" :
            "dataContextWrapper.current";
        try {
            // Create the expression as a function
            var evaluator = cache[bindingExpression] = new Function("dataContextWrapper", "$element", "var $data = " + currentDataContextExpression + ";\r\n\
  if ($data === null || $data === undefined) { \r\n\
    $data = {}; \r\n\
  } \r\n\
  var $value = $dyn.value;\r\n\
  var $format = $dyn.format;\r\n\
  var $label = $dyn.label;\r\n\
  var $parent = function (i) { return dataContextWrapper.parent(i); };\r\n\
  var $model = function (modelSelector, context) { return $dyn.bindingFunctions.$model(modelSelector, context !== undefined ? context : dataContextWrapper); };\r\n\
  var $modelCollection =  function (modelSelector, context) { return $dyn.bindingFunctions.$modelCollection(modelSelector, context !== undefined ? context : dataContextWrapper); };\r\n\
  var $models =  function (modelSelector, context) { return $dyn.bindingFunctions.$models(modelSelector, context !== undefined ? context : dataContextWrapper); };\r\n\
  var $field = function (fieldName, modelSelector) { return $dyn.getFieldObservable(fieldName, $model(modelSelector)); };\r\n\
  with (dataContextWrapper.scopeVars) { \r\n\
    if($data != null && !($data && $data.valueChanged)) { \r\n\
        with($data) \r\n\
        { \r\n\
            return  (" + bindingExpression + "); \r\n\
        } \r\n\
    } else { \r\n\
        return (" + bindingExpression + "); \r\n\
    } \r\n\
  }");
            return evaluator;
        }
        catch (error) {
            if ($dyn.debug.bindingErrorAsMessages) {
                $dyn.warn({ Message: $dyn.label("Invalid binding expression, see console for more details"), Label: "Invalid binding expression, see console for more details" });
            }
            $dyn.logError("Invalid binding expression: %s", bindingExpression);
            return (function () { });
        }
    }
    $dyn._parseBindingExpression = _parseBindingExpression;
    /**
     * Parses and gets the data-binding evaluator associated with the node
     * @description Parses and gets the data-binding evaluator associated with the node as a function that can be executed by passing in
     * the data-context. If no data-binding attribute exists, this returns null. This method caches the parsed data-binding
     * evaluator as an invokable function on the element's data
     */
    function _parseDataBinding(targetElement) {
        var evaluator;
        var dataBindAttr = targetElement.getAttribute("data-dyn-bind");
        if (dataBindAttr) {
            // Create the expression as a function
            evaluator = $dyn._parseBindingExpression(dataBindAttr, true);
        }
        else {
            evaluator = null;
        }
        return evaluator;
    }
    $dyn._parseDataBinding = _parseDataBinding;
    function getBindings(targetElement, dataContext) {
        var bindings;
        var dataBindAttr = targetElement.getAttribute("data-dyn-bind");
        if (dataBindAttr) {
            bindings = $dyn._bindingsCache[dataBindAttr];
            if (!bindings) {
                // Create the expression as a function
                bindings = $dyn._bindingsCache[dataBindAttr] = $dyn._parseBindingExpressions(dataBindAttr);
            }
        }
        else {
            bindings = null;
        }
        return bindings;
    }
    $dyn.getBindings = getBindings;
    $dyn._parseDataBindings = getBindings;
    /**
     * Parses an "data-dyn-bind" expression into a array of key/value pairs.
     * @description The key is the binding handler name. The value is an evaluator function built from a JS expression.
     * Unlike normal object literals it is possible for the binding handler to be specified more than once (useful for properties like attr).
     * Binding expressions do not contain any user data.  Binding expressions represents developer created functions which
     * are in turn used to evaluate user data.
     * Note: regular expressions are not fully supported in bindings.
     */
    function _parseBindingExpressions(input) {
        if (typeof input !== "string") {
            return;
        }
        // Add a comma to the end of the input to make tokenizing easier
        input += ",";
        // Use local variables for faster perf
        var semicolon = 58;
        var doubleQuote = 34;
        var backslash = 92;
        var singleQuote = 39;
        var comma = 44;
        var leftBrace = 123;
        var leftBracket = 91;
        var leftParentheses = 40;
        var rightBrace = 125;
        var rightBracket = 93;
        var rightParentheses = 41;
        var indentifier = 0;
        var expression = 1;
        var singleQuoteString = 2;
        var doubleQuoteString = 3;
        var expressions = [];
        var lastTokenIndex = 0;
        var currentIdentifier;
        var currentExpression;
        var state = indentifier;
        var depth = 0;
        // Does a single pass tokenizing/parsing, with single character look behind for detecting strings.
        // Binding expressions are JS object literals without the outermost curly braces.
        // Does not validate that the expression can be parse by the JS parser.  An unbalanced string/brace can result in an syntax error when the function
        // is evaluated.
        for (var i = 0; i < input.length; i++) {
            var c = input.charCodeAt(i);
            if (state === indentifier) {
                // The binding handler name is an identifier and is followed by a semicolon.
                if (c === semicolon) {
                    state = 1;
                    currentIdentifier = input.slice(lastTokenIndex, i);
                    lastTokenIndex = i + 1;
                }
            }
            else if (state === doubleQuoteString) {
                if (c === doubleQuote && input.charCodeAt(i - 1) !== backslash) {
                    // The ending double quote is not escaped, marks the end of the string.
                    state = expression;
                }
            }
            else if (state === singleQuoteString) {
                if (c === singleQuote && input.charCodeAt(i - 1) !== backslash) {
                    // The ending single quote is not escaped, marks the end of the string.
                    state = expression;
                }
            }
            else {
                // Parses an expression
                switch (c) {
                    case comma:
                        if (depth === 0) {
                            // TODO: Trim seems to be fast in perf tests but is it faster to do the trim in the parsing?
                            currentIdentifier = currentIdentifier.trim();
                            currentExpression = input.slice(lastTokenIndex, i);
                            if (currentIdentifier) {
                                var newExpression = {};
                                newExpression[currentIdentifier] = $dyn._parseBindingExpression(currentIdentifier + ": " + currentExpression, true);
                                expressions.push(newExpression);
                            }
                            else {
                                $dyn.logWarning("Syntax error: missing binding handler name: %s", input);
                            }
                            // End of expression token, skip the comma token
                            lastTokenIndex = i + 1;
                            // Start tokenizing the next identifier
                            state = indentifier;
                        }
                        break;
                    case leftBrace:
                    case leftBracket:
                    case leftParentheses:
                        // Note: Does not require a stack because correct balancing is not checked by this parser.
                        // That is checked by the JS parser when the functions are compiled.
                        // Only the depth is tracked so that it is known if the expression can being terminated by a comma.
                        depth++;
                        break;
                    case rightBrace:
                    case rightBracket:
                    case rightParentheses:
                        depth--;
                        break;
                    case doubleQuote:
                        state = doubleQuoteString;
                        break;
                    case singleQuote:
                        state = singleQuoteString;
                        break;
                }
            }
        }
        if (state !== indentifier && input.length > 0) {
            // Ended up in a unexpected state (still parsing an expression)
            // This can happen if the expression has unbalanced elements such as an extra parentheses in it.
            currentIdentifier = currentIdentifier.trim();
            // Remove the extra comma that we added
            currentExpression = input.slice(lastTokenIndex);
            var newExpression = {};
            // While parsing the expression if there is a syntax error then an empty function is returned.
            newExpression[currentIdentifier] = $dyn._parseBindingExpression(currentIdentifier + ": " + currentExpression, true);
            expressions.push(newExpression);
            $dyn.logWarning("Syntax error: '%s' for binding '%s'", currentExpression, currentIdentifier);
        }
        return expressions;
    }
    $dyn._parseBindingExpressions = _parseBindingExpressions;
    /**
     * Checks whether an element has data-binding attribute and expression specified on it.
     */
    function hasDataBinding(targetElement) {
        return !!targetElement.getAttribute("data-dyn-bind");
    }
    $dyn.hasDataBinding = hasDataBinding;
    function parseModel(modelSelector, dataContext) {
        if (modelSelector === undefined || modelSelector === null) {
            // Context is taken to be the model
            return dataContext;
        }
        if (dataContext && "DataSource" in dataContext) {
            dataContext = dataContext.DataSource;
        }
        if (typeof modelSelector === "string") {
            // The model selector is taken to be a navigation property name in the current model-context
            return $dyn.getModel(modelSelector, dataContext);
        }
        else {
            // The modelSelector is taken to be the model
            return modelSelector;
        }
    }
    $dyn.parseModel = parseModel;
    /**
     * Parses an modelSelector expression within a data-context to resolve to a model collection
     */
    function parseModelCollection(modelSelector, dataContext, returnCollection) {
        if (modelSelector === undefined || modelSelector === null) {
            // Context is taken to be the model collection
            return dataContext;
        }
        if (dataContext && "DataSource" in dataContext) {
            dataContext = dataContext.DataSource;
        }
        if (typeof modelSelector === "string") {
            // The model selector is taken to be a navigation property name in the current model-context
            return $dyn.getModelCollection(modelSelector, dataContext, returnCollection);
        }
        else {
            // The modelSelector is taken to be the model collection
            return modelSelector;
        }
    }
    $dyn.parseModelCollection = parseModelCollection;
    /**
     * Gets an observable that represents the model obtained by the navigationProperty in the given model context.
     * @description In the case the model context is backed by an ActiveModelCollection, this always returns the active model
     * of the navigation model collection.
     */
    function getModel(navigationProperty, modelContext) {
        if (!modelContext) {
            return null;
        }
        if (!modelContext.navigationObservables) {
            // Maintain a navigation observable collection so that we do not keep creating observables
            modelContext.navigationObservables = {};
        }
        if (!modelContext.navigationObservables[navigationProperty]) {
            modelContext.navigationObservables[navigationProperty] = $dyn.computed(function getModel_getter() {
                var modelContextValue = $dyn.value(modelContext);
                if (modelContextValue) {
                    if (modelContextValue.getRelated) {
                        return $dyn.value(modelContextValue.getRelated(navigationProperty));
                    }
                    else {
                        return modelContextValue[navigationProperty];
                    }
                }
            });
            // Annotate the computed with the property name
            modelContext.navigationObservables[navigationProperty].__getModel = navigationProperty;
        }
        return modelContext.navigationObservables[navigationProperty];
    }
    $dyn.getModel = getModel;
    /**
     * Gets an observable that represents the model collection obtained by the navigationProperty in the given model context.
     */
    function getModelCollection(navigationProperty, modelContext, returnCollection) {
        if (!modelContext) {
            return null;
        }
        // The context is already a model collection.
        // todo should we throw instead
        if ($dyn.serverForm && $dyn.serverForm.isModelCollection(modelContext)) {
            return modelContext;
        }
        var observableType = returnCollection ? "__navigationCollectionObservables" : "__navigationItemsObservables";
        if (!modelContext[observableType]) {
            // Maintain a navigation collection observable collection so that we do not keep creating observables
            modelContext[observableType] = {};
        }
        var modelCollection = modelContext[observableType][navigationProperty];
        if (!modelCollection) {
            modelCollection = modelContext[observableType][navigationProperty] = $dyn.computed(function getModelCollection_getter() {
                var modelContextValue = $dyn.value(modelContext);
                // The context is already a model collection.
                // todo should we throw instead
                if (modelContextValue instanceof Array) {
                    return modelContextValue;
                }
                if (modelContextValue) {
                    if (modelContextValue.getRelatedCollection) {
                        var collection = $dyn.value(modelContextValue.getRelatedCollection(navigationProperty));
                        if (collection) {
                            if (returnCollection) {
                                return collection;
                            }
                            else {
                                return $dyn.value(collection.items);
                            }
                        }
                    }
                    else {
                        return modelContextValue[navigationProperty];
                    }
                }
                return null;
            });
        }
        return modelCollection;
    }
    $dyn.getModelCollection = getModelCollection;
    /**
     * Gets the value of a model field.
     * @description The value is obtained through an observable, thus accessing it
     * in an observable scope would make any changes auto-observed for future changes.
     */
    function getFieldObservable(fieldName, modelContext) {
        // If the model-context is be null, ignore
        if (modelContext == null) {
            return null;
        }
        // If the model context is observable, we will need to create an observable on context before unwrapping it
        // To save the number of observables created, the observables are cached by fieldName on the context observable
        if (modelContext && modelContext.valueChanged) {
            if (!modelContext.fieldObservables) {
                modelContext.fieldObservables = {};
            }
            if (!modelContext.fieldObservables[fieldName]) {
                modelContext.fieldObservables[fieldName] = $dyn.computed(function getFieldObservable_getter() {
                    // Recursively call the fieldObservable method with the unwrapped model
                    return $dyn.value($dyn.getFieldObservable(fieldName, $dyn.value(modelContext)));
                }, function getFieldObservable_setter(value) {
                    var fieldObservable = $dyn.getFieldObservable(fieldName, $dyn.value(modelContext));
                    if (fieldObservable) {
                        fieldObservable(value);
                    }
                });
                // Annotate the computed with the field name
                modelContext.fieldObservables[fieldName].__getFieldObservable = fieldName;
            }
            return modelContext.fieldObservables[fieldName];
        }
        // Now we are certain that the modelContext is fully unwrapped
        var model = modelContext;
        // If the model turns out to be null, ignore
        if (!model) {
            return null;
        }
        // Model field name is different than the public field name
        var modelFieldName = fieldName;
        if (!model.fieldObservables) {
            // Maintain a field observable collection so that we do not keep creating observables
            // Field observables are computed observables which get/set values directly from model
            model.fieldObservables = {};
            // Field trackers track any changes made to a particular field by incrementing tracking version
            model.fieldTrackers = {};
        }
        if (!model.fieldObservables[modelFieldName]) {
            // Create the tracker on the field
            var fieldTracker_1 = model.fieldTrackers[modelFieldName] = $dyn.observable(1);
            // Create a computed observable on this field
            model.fieldObservables[modelFieldName] = $dyn.computed(function () {
                // Getter method
                fieldTracker_1(); // latch on to tracker dependency
                if (model.getValue) {
                    return model.getValue(modelFieldName);
                }
                else {
                    return model[modelFieldName];
                }
            }, function (value) {
                if (model.setValue) {
                    model.setValue(modelFieldName, value);
                }
                else {
                    model[modelFieldName] = value;
                }
            });
        }
        return model.fieldObservables[modelFieldName];
    }
    $dyn.getFieldObservable = getFieldObservable;
    /**
     * Gets or sets an observable value on a model field.
     */
    function getFieldValue(fieldName, modelContext, newValue) {
        // The observable built on top of the field value accessor
        // Need to ensure whether to get or set based on the newValue - calling with arg would cause a set
        return newValue !== undefined ? $dyn.getFieldObservable(fieldName, modelContext)(newValue) : $dyn.value($dyn.getFieldObservable(fieldName, modelContext));
    }
    $dyn.getFieldValue = getFieldValue;
    /**
     * Finds the collection of bindable children of the given element
     */
    function getBindableChildren(targetElement) {
        return targetElement.children;
    }
    $dyn.getBindableChildren = getBindableChildren;
    function getModelName(dataSourceName, dataSource) {
        dataSource = $dyn.value(dataSource);
        dataSourceName = $dyn.value(dataSourceName);
        if (!dataSource || dataSource.GetNavigationCollection) {
            dataSourceName += "_ds";
        }
        return dataSourceName;
    }
    $dyn.getModelName = getModelName;
    function getFieldName(fieldName, model) {
        model = $dyn.value(model);
        fieldName = $dyn.value(fieldName);
        if (!model || model.GetNavigationProperty) {
            fieldName += "_field";
        }
        return fieldName;
    }
    $dyn.getFieldName = getFieldName;
})($dyn || ($dyn = {}));

//# sourceMappingURL=DataBinding.js.map
